import React from 'react';
import CourseCardsGrid from './CourseCardsGrid';
import { instructorProfile } from '../data/siteInfo';
import '../styles/PracticeHome.css';

const PracticeHome = () => {
  return (
    <div className="practice-home" id="practice-home">
      <section className="practice-home-hero">
        <h1 className="practice-home-title">Selenium Practice Website for Automation Testing</h1>
        <p className="practice-home-lead">
          Free hands-on Selenium practice website for UI automation testing. Use the sidebar to explore text boxes, alerts, iframes, dropdowns, tables, and more.
        </p>
        <p className="practice-home-developed">
          Developed by <strong>{instructorProfile.name}</strong>
        </p>
      </section>

      <section className="practice-home-section practice-home-about" id="about-instructor">
        <h2 className="practice-home-section-title">About Me</h2>
        <div className="practice-home-about-card">
          <div className="practice-home-about-header">
            <div className="practice-home-avatar" aria-hidden="true">SK</div>
            <div>
              <h3 className="practice-home-name">{instructorProfile.name}</h3>
              <p className="practice-home-role">{instructorProfile.role}</p>
            </div>
          </div>
          <p className="practice-home-text practice-home-bio">{instructorProfile.bio}</p>
          <div className="practice-home-links">
            <a
              href={instructorProfile.udemyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="practice-home-link"
            >
              View Udemy Profile
            </a>
            <a
              href={instructorProfile.linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="practice-home-link practice-home-link-secondary"
            >
              Connect on LinkedIn
            </a>
          </div>
        </div>
      </section>

      <section className="practice-home-section practice-home-courses-section" id="udemy-courses">
        <div className="practice-home-courses-header">
          <h2 className="practice-home-section-title">My Udemy Courses</h2>
          <p className="practice-home-text practice-home-courses-intro">
            Structured courses to help you master programming, automation testing, and generative AI.
          </p>
        </div>
        <CourseCardsGrid />
      </section>
    </div>
  );
};

export default PracticeHome;
